import { render, staticRenderFns } from "./CouponField.vue?vue&type=template&id=4d0e36fc&"
import script from "./CouponField.vue?vue&type=script&lang=ts&"
export * from "./CouponField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports